/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: () => ({
        availabilityBlock: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            flexWrap: 'nowrap',
            marginBottom: '16px'
        },
        status: {
            float: 'left',
            fontSize: '14px',
            color: '#000',
            lineHeight: 'normal',
            paddingRight: '5px',
            fontWeight: '700',
            margin: '0'
        },
        maxOrderLimitText: {
            fontSize: '14px',
            color: '#008a89',
            lineHeight: 'normal',
            fontWeight: '700'
        }
    }),
    parts: ['availabilityBlock', 'status', 'maxOrderLimitText']
}
